/**
 * A site-relative path to a file (an agreement, a deck) rather than an app
 * route. It needs a full page load: the client router would render its 404 page.
 */
export function isStaticDocumentHref(href: string): boolean {
  return /^\/[^?#]*\.[a-z0-9]+(?:[?#]|$)/i.test(href);
}
